/**
 * plugins/webfontloader.js
 *
 * webfontloader documentation: https://github.com/typekit/webfontloader
 */
import "@styles/fonts.css";

export async function loadFonts() {
  const webFontLoader = await import(
    /* webpackChunkName: "webfontloader" */ "webfontloader"
  );

  console.log("Loading fonts...");

  webFontLoader.load({
    google: {
      families: ["Montserrat:400,700", "Inter:400,500,600,700", "Roboto:900", "Rajdhani:400,500,600,700", "Share Tech Mono"],
    },
    custom: {
      families: [],
      urls: ["./styles/fonts.css"],
    },
  });
}

export default function () {
  loadFonts();
}
